import indicatorList from '@/mixins/IndicatorList';
import { KButton, KInput } from '@/components';
import { storyblok } from '@/config';

// helpers
import countries from '@/utils/countries';
import searchSuggestions from '@/utils/searchSuggestions';
import { queryDataset } from '../../../api/search';

export default {
  name: 'Search',
  mixins: [indicatorList],
  components: {
    KInput,
    KButton,
  },
  data: () => ({
    showAdvanced: false,
    suggested: [],
    category: '',
    indicator: '',
    country: '',
    countries,
    value: '',
    isSearching: false,
    suggestions: [],
    suggestedSearches: [
      { term: 'What is the GDP of Nigeria?', link: '/' },
      { term: 'Algeria’s GDP in 2017?', link: '/' },
      { term: 'Ghana’s Growth Rate of Quartely GDP by Economic Activities', link: '/' },
      { term: 'Ghana’s  GDP in 2022', link: '/' },
      { term: 'Oil contribution to Nigeria’s GDP', link: '/' },
      { term: 'Nigeria’s percentage of world oil contribution', link: '/' },
      { term: "Nigeria's debt-to-GDP ratio was 36.63% in the year 2021.", link: '/' },
    ],
    isLoading: false,
  }),
  created() {
    const { query } = this.$route;
    this.country = query.country || '';
    this.category = query.category || '';
    this.indicator = query.indicator || '';
  },
  computed: {
    advancedSearchReady() {
      return this.indicator && this.country;
    },
    sortedSuggestions() {
      const suggestions = this.suggestions.map((s) => s.searchTerm);
      // suggestions.sort((a, b) => String(a).localeCompare(String(b)));

      return suggestions.slice(0, 5);
    },
    chunkedSearches() {
      return this.chunkArray(this.suggestedSearches, 3);
    },
  },
  watch: {
    country(val) {
      console.log('country function');
      const { $route: r } = this;
      if (val.toLocaleString() !== r.query.country?.toLowerCase()) {
        const newRoute = { ...r };
        newRoute.query = { ...r.query, country: val };
        this.$router.push(newRoute);
      }
    },
    showAdvanced(val) {
      console.log('showAdvanced function');
      const showingAdvanced =
        this.$route.fullPath.includes('/search') && this.$route.fullPath.includes('#advanced');
      if (val && !showingAdvanced) {
        this.$router.replace({ name: 'Search', hash: '#advanced' });
      } else if (!val && showingAdvanced) {
        this.$router.replace({ name: 'Search', hash: '' });
      }
    },
    async value(val) {
      console.log('async function');
      // searchSuggestions.call(this, val);
    },
  },
  methods: {
    async goToSearch(search = '') {
      const searchTerm = search.trim() || this.value.trim();
      if (searchTerm) {
        this.isLoading = true;
        try {
          const response = await this.$store.dispatch('search/search', searchTerm);

          if (response.is_data) {
            const r = response.analysis_payload.relevant_data;
            const path = `/indicators/${encodeURIComponent(
              response.analysis_payload.user_query
            )}/${encodeURIComponent(r.metadata.country)}`;
            const query = {
              category: r.metadata.category,
              frequency: r.metadata.frequency,
              chartType: 'line',
              colour: '#23900F7B',
              startYear: r.metadata.min_date,
              endYear: r.metadata.max_date,
              country: r.metadata.country,
              indicator: response.analysis_payload.user_query,
            };

            this.$router.push({ path, query });
          } else {
            this.$router.push({ name: 'Results', query: { q: encodeURIComponent(searchTerm) } });
          }
        } catch (error) {
          this.$toast.show({
            message: 'Something unexpected occurred on the server',
          });
        } finally {
          this.isLoading = false;
        }
      }
    },
    advancedSearch() {
      const { indicator, country, category } = this;
      this.$router.push({
        name: 'AdvancedSingleResult',
        params: { indicator, country },
        query: { category },
      });
    },
    chunkArray(arr, size) {
      return Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
        arr.slice(i * size, i * size + size)
      );
    },

    // expanding textarea
    autoResize() {
      const el = this.$refs.textarea;
      el.style.height = 'auto'; // Reset height
      el.style.height = el.scrollHeight + 'px'; // Set to scrollHeight
    }

  },
  async mounted() {
    this.getIndicators();
    const {
      $route: { hash },
    } = this;
    if (hash && hash === '#advanced') {
      this.showAdvanced = true;
    }

    this.suggested = await storyblok
      .get('/stories?content_type=Post&per_page=5&page=1')
      .then(({ data }) => data)
      .then(({ stories }) => stories);
  },
};
